import { trackFilterChange } from '../utils/tracking/searchBrowse/filterTracking';
import { decode64 } from '../utils/decode';

export const TOGGLE_FILTER_DISPLAY = 'TOGGLE_FILTER_DISPLAY';
export function toggleFilterDisplay(shown) {
    return { type: TOGGLE_FILTER_DISPLAY, filtersShown: shown };
}

export const TOGGLE_REQUEST_IN_FLIGHT = 'TOGGLE_REQUEST_IN_FLIGHT';
export function toggleRequestInFlight(payload) {
    return { type: TOGGLE_REQUEST_IN_FLIGHT, payload };
}

export const UPDATE_URI_REF = 'UPDATE_URI_REF';
export function updateUriRef({
    filterName,
    filterValue,
    uriRef,
    isFromTypeahead = false,
    isDeselected = false,
}) {
    if (!uriRef) {
        const { linkReference } = filterValue;
        uriRef = linkReference && decode64(linkReference);
    }

    trackFilterChange({ filterName, filterValue, isFromTypeahead, isDeselected });
    return { type: UPDATE_URI_REF, payload: uriRef };
}

export const UPDATE_ZIP_CODE = 'UPDATE_ZIP_CODE';
export function updateZipCode(zipCode) {
    return { type: UPDATE_ZIP_CODE, payload: zipCode };
}

export const SET_SEMANTIC_SEARCH_TERM = 'SET_SEMANTIC_SEARCH_TERM';
export function setSemanticSearchTerm(semanticSearchTerm) {
    return { type: SET_SEMANTIC_SEARCH_TERM, payload: semanticSearchTerm };
}
